import { render, staticRenderFns } from "./ReviewProductSelector.vue?vue&type=template&id=7a3aed78"
import script from "./ReviewProductSelector.ts?vue&type=script&lang=ts&external"
export * from "./ReviewProductSelector.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3aed78')) {
      api.createRecord('7a3aed78', component.options)
    } else {
      api.reload('7a3aed78', component.options)
    }
    module.hot.accept("./ReviewProductSelector.vue?vue&type=template&id=7a3aed78", function () {
      api.rerender('7a3aed78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/ReviewProductSelector/ReviewProductSelector.vue"
export default component.exports